import { Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer py-4 bg-transparent">
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="6">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="https://www.pal.co.uk/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Packaging Automation Ltd
            </a>
          </div>
        </Col>

        <Col xl="6">
          <Nav className="nav-footer justify-content-center justify-content-xl-end">
            <NavItem>
              <NavLink
                href="https://www.pal.co.uk/machine-monitoring/miassist/"
                rel="noopener noreferrer"
                target="_blank"
              >
                MiAssist
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://www.pal.co.uk/about/timeline-history/"
                rel="noopener noreferrer"
                target="_blank"
              >
                About Us
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://www.pal.co.uk/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Solutions
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://www.pal.co.uk/contact/our-contacts/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Contact
              </NavLink>
            </NavItem>
          </Nav>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
